// Vuex transaction module actions
import { FILL_DETAILS } from './mutations-types';
import { API } from '@/config';

export default {
  async getDetailsListening({ commit }, connection) {
    try {
      commit(FILL_DETAILS, {
        record: `${process.env.VUE_APP_API_URL}/record/getDetails?connection=${connection}&is_listening=true`,
      });
    } catch (err) {
      console.log(err);
    }
  },

  async getRecordsZip(context, params) {
    try {
      return await API.post('/record/downloadZipWithoutMS', { ...params });
    } catch (err) {
      return err.response.data;
    }
  },

  async getDetailsDownload(contex, params) {
    let response;
    try {
      response = await API.get('/record/getDetails', { params });
    } catch (err) {
      console.log(err);
    }
    return response;
  },
  async removeRecord(context, data) {
    try {
      await API.delete('/record/removeRecord', { data });
    } catch (e) {
      console.log(e);
    }
  },
};
